import { render, staticRenderFns } from "./report-summary.vue?vue&type=template&id=42510af9&scoped=true&"
import script from "./report-summary.vue?vue&type=script&lang=js&"
export * from "./report-summary.vue?vue&type=script&lang=js&"
import style0 from "./report-summary.vue?vue&type=style&index=0&id=42510af9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42510af9",
  null
  
)

export default component.exports